// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "mail." + chunkId + "." + {"8":"f2a664ed779de2ba231e","66":"0deda3fa19f7f2503a5a","471":"bdf7ee551f1a2e6dfc94","516":"529573d60f37aeba9485","862":"856324fd144da45d0628"}[chunkId] + ".js";
};